<div>
  <h3>Google Photos Frame</h3>

  <div>
    <a href="/api/photoframe/authorize">Authorize this app to use your Google Photos</a>
  </div>

  <br /><br /><br /><br /><br /><br /><br />
</div>

